import PropTypes from "prop-types";
import React from "react";

import useWorkflowPage from "./use_workflow_page";
import WorkflowPage from "./workflow_page";

const WorkflowController = ({ section }) => {
  const initPage = {
    tab: section,
    isEngagementEnabled: false,
    isRoleEnabled: false,
    isPlannerEnabled: false,
    engagements: {
      data: { entries: [], meta: { total: 0, filters: {}, counters: {}, order: {} }, loading: false },
      loaded: false,
      columns: []
    },
    roles: {
      data: { entries: [], meta: { total: 0, filters: {}, counters: {}, order: {} }, loading: false },
      loaded: false,
      columns: []
    },
    planner: {
      data: { entries: [], meta: { total: 0, filters: {} } },
      loading: false,
      loaded: false
    },
    initialized: false
  };

  const { initialized } = useWorkflowPage(initPage);

  return initialized && <WorkflowPage />;
};

WorkflowController.propTypes = {
  section: PropTypes.oneOf(["engagements", "roles", "planner"])
};

export default WorkflowController;
